module.exports = __webpack_public_path__ + "static/23a05d0f513037daf66538cd2e0de2d16af1422e97a2f847528a6ca8c0be272a-7468a8ac98cb0b79f4fd2f2e9a16db33.jpeg";